export const GET_CONTENT_BY_REFERENCE = 'studyMain/GET_CONTENT_BY_REFERENCE';
export const LOAD_SKT_BIBS_COUNTERS = 'studyMain/LOAD_SKT_BIBS_COUNTERS';
export const SET_SKT_COUNTERS = 'studyMain/SET_SKT_COUNTERS';
export const GET_BY_DISABLED_CHAPTER = 'studyMain/GET_BY_DISABLED_CHAPTER';
export const SET_CONTENT_BY_REFERENCE = 'studyMain/SET_CONTENT_BY_REFERENCE';
export const GET_QUESTIONS_BY_FAVORITE = 'studyMain/GET_QUESTIONS_BY_FAVORITE';
export const GET_QUESTIONS_BY_MY_FAVORITE =
  'studyMain/GET_QUESTIONS_BY_MY_FAVORITE';
export const GET_QUESTIONS_BY_MY_SUBMITTED =
  'studyMain/GET_QUESTIONS_BY_MY_SUBMITTED';
export const SET_FAVORITE_QUESTIONS_FOR_STUDY =
  'studyMain/SET_FAVORITE_QUESTIONS_FOR_STUDY';

export const SET_IS_LOADING_PDF_LINK =
  'studyMain/studyMain/SET_IS_LOADING_PDF_LINK';
export const SET_IS_LOADING_SKT_DATA = 'studyMain/SET_IS_LOADING_SKT_DATA';
export const SET_IS_LOADING_REFERENCES = 'studyMain/SET_IS_LOADING_REFERENCES';
export const SET_PDF_LINK = 'studyMain/studyMain/SET_PDF_LINK';

export const GET_CONTENT_BY_WARFARE_QUALS = `studyMain/GET_CONTENT_BY_WARFARE_QUALS`;
export const SET_CONTENT_BY_WARFARE_QUALS = `studyMain/SET_CONTENT_BY_WARFARE_QUALS`;

export const GET_CONTENT_BY_STUDY_ALL = `studyMain/GET_CONTENT_BY_STUDY_ALL`;
export const SET_CONTENT_BY_STUDY_ALL = `studyMain/SET_CONTENT_BY_STUDY_ALL`;

export const GET_QUAL_FROM_ID = `studyMain/GET_QUAL_FROM_ID`;
export const SET_QUAL_FROM_ID = `SstudyMain/ET_QUAL_FROM_ID`;

// ----Questions/Answer Flow

export const GET_QUESTIONS_BY_RATE = `studyMain/GET_QUESTIONS_BY_RATE`;
export const SET_QUESTIONS_BY_RATE = `studyMain/SET_QUESTIONS_BY_RATE`;

export const GET_QUESTIONS_BY_PERSONALIZED_STUDY_ALL = `studyMain/GET_QUESTIONS_BY_PERSONALIZED_STUDY_ALL`;
export const GET_QUESTIONS_BY_QUALS = `studyMain/GET_QUESTIONS_BY_QUALS`;
export const SET_QUESTIONS_BY_QUALS = `studyMain/SET_QUESTIONS_BY_QUALS`;

export const SET_COUNT_QUESTIONS = `SET_COUNT_QUESTIONS`;
export const SET_RECAPTCHA_TIME = `SET_RECAPTCHA_TIME`;
export const ADD_COUNT_QUESTIONS = `ADD_COUNT_QUESTIONS`;

export const GET_QUESTIONS_BY_CHAPTER = `studyMain/GET_QUESTIONS_BY_CHAPTER`;
export const SET_QUESTIONS_BY_CHAPTER = `studyMain/SET_QUESTIONS_BY_CHAPTER`;

export const SEND_ANSWER = `studyMain/SEND_ANSWER`;
export const FAVORITE_QUESTION = `studyMain/FAVORITE_QUESTION`;
export const SET_ANSWER_RESPONSE = `studyMain/SET_ANSWER_RESPONSE`;
export const GET_ANSWER_RESPONSE = `studyMain/GET_ANSWER_RESPONSE`;
export const UPDATE_COUNTERS = `studyM/UPDATE_COUNTERS`;

export const SET_QUESTION = `studyMain/SET_QUESTION`; // this will be the action that sets the question that the user answers.
export const SET_PREVIOUS_QUESTION = `studyMain/SET_PREVIOUS_QUESTION`; // this will be the action that sets the question that the user answers.
export const PREVIOUS_QUESTION_TO_ACTUAL = `studyMain/PREVIOUS_QUESTION_TO_ACTUAL`;
export const SET_PREVIOUS_COUNTERS = `studyMain/SET_PREVIOUS_COUNTERS`;
export const PREVIOUS_COUNTERS_TO_ACTUAL = `studyMain/PREVIOUS_COUNTERS_TO_ACTUAL`;
export const SET_BACKED_STATE_TO_QUESTION = `studyMain/SET_BACKED_STATE_TO_QUESTION`; // we need this field to limit the previous question query to just 1 query
export const SET_COUNTERS = `studyMain/SET_COUNTERS`;
export const SET_MORE_QUESTIONS = `studyMain/SET_MORE_QUESTIONS`;

export const SET_IS_LOADING_QUESTIONS = 'studyMain/SET_IS_LOADING_QUESTIONS';

export const MESSAGE_ERROR_GET_QUESTIONS =
  'studyMain/MESSAGE_ERROR_GET_QUESTIONS';

// -----We are going to use the next actions to know if we are using a chapter, a qual or rate id

export const IS_CHAPTER = `studyMain/IS_CHAPTER`;
export const IS_QUAL = `studyMain/IS_QUAL`;
export const IS_STUDY_PLAN = `studyMain/IS_STUDY_PLAN`;

export const CLEAN_QUESTIONS = `studyMain/CLEAN_QUESTIONS`;

export const SET_BACK_TO = 'studyMain/SET_BACK_TO';
export const SET_CHAPTER_ID = 'studyMain/SET_CHAPTER_ID';
export const CHECK_CHAPTER_IN_REVIEW = 'studyMain/CHECK_CHAPTER_IN_REVIEW';

export const UPDATE_USERANSWERS = 'studyMain/UPDATE_USERANSWERS';

export const GET_PDF_BY_REFERENCE = 'studyMain/GET_PDF_BY_REFERENCE';

export const GET_POST_EXAM_CHECKLIST_PDF =
  'studyMain/GET_POST_EXAM_CHECKLIST_PDF';
export const SET_POST_EXAM_CHECKLIST_PDF_LINK =
  'studyMain/SET_POST_EXAM_CHECKLIST_PDF_LINK';
export const SET_IS_LOADING_POST_EXAM_CHECKLIST_PDF =
  'studyMain/SET_IS_LOADING_POST_EXAM_CHECKLIST_PDF';

export const BREADCRUMS_QUALS_AND_CERTS =
  'studyMain/BREADCRUMS_QUALS_AND_CERTS';

export const LOAD_FAVORITE_QUESTION = 'studyMain/LOAD_FAVORITE_QUESTION';

export const SET_FAVORITE_MESSAGE = 'studyMain/SET_FAVORITE_MESSAGE';

export const SET_IS_STUDY_FAVORITE_QUESTION =
  'studyMain/SET_IS_STUDY_FAVORITE_QUESTION';

export const SET_COUNTER_FAVORITE = 'studyMain/SET_COUNTER_FAVORITE';
export const SET_COUNTER_MY_FAVORITE = 'studyMain/SET_COUNTER_MY_FAVORITE';

export const SET_COUNTER_SUBMITTED = 'studyMain/SET_COUNTER_SUBMITTED';
export const SET_COUNTER_MY_SUBMITTED = 'studyMain/SET_COUNTER_MY_SUBMITTED';
export const GET_QUESTIONS_BY_SUBMITTED =
  'studyMain/GET_QUESTIONS_BY_SUBMITTED';
export const SET_SUBMITTED_QUESTIONS = 'studyMain/SET_SUBMITTED_QUESTIONS';
export const SET_IS_STUDYING_SUBMITTED_QUESTIONS =
  'studyMain/SET_IS_STUDYING_SUBMITTED_QUESTIONS';
export const SET_IS_STUDYING_MY_FAVORITE_QUESTIONS =
  'studyMain/SET_IS_STUDYING_MY_FAVORITE_QUESTIONS';
export const SET_IS_STUDYING_MY_SUBMITTED_QUESTIONS =
  'studyMain/SET_IS_STUDYING_MY_SUBMITTED_QUESTIONS';
export const SET_DISABLED_CHAPTER = 'studyMain/SET_DISABLED_CHAPTER';
export const UPDATE_DISABLED_CHAPTER = 'studyMain/UPDATE_DISABLED_CHAPTER';
export const GET_AUDIO_PLAYLIST = 'studyMain/GET_AUDIO_PLAYLIST';
export const SET_AUDIO_PLAYLIST = 'studyMain/SET_AUDIO_PLAYLIST';
export const RESET_CHAPTER = 'studyMain/RESET_CHAPTER';
export const SET_RESET_CHAPTER = 'studyMain/SET_RESET_CHAPTER';
export const SET_RESET_CHAPTER_MESSAGE = 'studyMain/SET_RESET_CHAPTER_MESSAGE';
export const LOAD_RESET_CHAPTER = 'studyMain/LOAD_RESET_CHAPTER';

export const GET_AUDIO_PLAYLISTS_PROGRESS =
  'studyMain/GET_AUDIO_PLAYLISTS_PROGRESS';
export const ADD_AUDIO_PLAYLISTS_PROGRESS =
  'studyMain/ADD_AUDIO_PLAYLISTS_PROGRESS';
export const UPDATE_AUDIO_PLAYLIST_PROGRESS =
  'studyMain/UPDATE_AUDIO_PLAYLIST_PROGRESS';
